import { imagePathResolver } from '@shared/utils';
import type { ArticlePreviewCardProps } from '../ArticlePreviewCard';
import { buildMagazinePageHref } from './buildMagazinePageHref';
import type { MagazineArticle } from './magazineCategory';

type MapArticleToPreviewCardOptions = {
  priority?: boolean;
};

function mapArticleToPreviewCard(article: MagazineArticle, baseImgUrl: string, options: MapArticleToPreviewCardOptions = {}): ArticlePreviewCardProps {
  return {
    title: article.title,
    href: article.seoInfo.canonicalUrl,
    publishedDate: article.publishedDate,
    author: article.author.name,
    authorHref: article.author.slug ? buildMagazinePageHref({ type: 'author', authorSlug: article.author.slug }, 1) : undefined,
    imageSrc: imagePathResolver(article.featuredImage?.filePath ?? '', baseImgUrl),
    imageAlt: article.featuredImage?.altText,
    category: article.category?.title,
    priority: options.priority ?? false,
  };
}

export { mapArticleToPreviewCard, type MapArticleToPreviewCardOptions };
